import React from "react";
import "./AgreementsHeader.css";

const AgreementsHeader = () => {
  return (
    <section className="AgreementsHeader-container">
      <div className="AgreementsHeader-overlay">
        <div className="container" style={{ textAlign: "center" }}>
          <h1 className="AgreementsHeader-title">Our Service Agreements</h1>
          <div className="AgreementsHeader-breadcrumb">
            <button className="btn btn-primary">
              Home - Service Agreements
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AgreementsHeader;
